// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_i7-0";
export var optionCard = "_i7-1";